<template>
    <div class="particpant">
        <tenders-stat-table 
            v-if="years.length" 
            type="participants" 
            :years="years.slice().reverse()" 
            :stat="stat"
            ref="table" 
        />
        <tenders-tile-charts 
            v-if="stat && productsStat && years.length" 
            :stat="stat"
            :productsStat="productsStat"  
            :years="years" 
            type="participants" 
        />
    </div>
</template>

<script>
import tendersStatTable from '@/components/card/tenders/tendersStatTable.vue'
import tendersTileCharts from '@/components/card/tenders/tendersTileCharts.vue'

export default {
    components: {
        tendersStatTable,
        tendersTileCharts
    },
    computed: {
        years() { return this.$store.getters['card/tenders/participantYears'] },
        stat() { return this.$store.state.card?.tenders?.stats?.participant || {} },
        productsStat() { return this.$store.state.card?.tenders?.productsStat?.participant }
    }
}
</script>

<style lang="sass" scoped>

</style>